<template>
  <div class="">
    <p>{{ featureSelectedAttribute }}</p>

    <input @keyup="manageSearchBox()" placeholder="جست و جو کنید." type="text" class="form-control" v-model="words">
    <div class="words-list-search border d-none shadow p-2 my-2" ref="searchBox">
      <p @click="setSelectedItem(item)" v-for="item in featureAttributesSearch">{{ item.value }}</p>
    </div>

  </div>
</template>

<script>
import StepOptions1 from "./StepOptionManager/StepOptions1.vue";

export default {
  name: "FeatureInputList2",
  components: {StepOptions1},
  data() {
    return {
      listStepVariableWatcher: null,
      words: ''
    }
  },
  props: {
    featureProduct: {},
    product: {},
  },
  computed: {
    featureAttributes() {
      return this.featureProduct.feature.feature_attributes
    },
    featureSelectedAttribute() {
      let feature_attribute_id = this.featureProduct.feature_attribute_id;
      if (feature_attribute_id != null) {

        for (const [_, item] of Object.entries(this.featureAttributes)) {
          if (item.id === feature_attribute_id) {
            return item.value
          }
        }

      }
    },
    featureAttributesSearch() {
      return this.featureAttributes.filter(item => {
        return item.value.indexOf(this.words) > -1
      }).slice(0, 20)
    }
  },
  methods: {
    setSelectedItem(item) {
      this.featureProduct.feature_attribute_id = item.id
      this.words = ''
    },
    manageSearchBox() {
      let element = this.$refs.searchBox
      if (this.words.length > 0) {
        element.classList.remove('d-none')
      } else {
        element.classList.add('d-none')
      }
    }
  },
}
</script>

<style scoped>
.words-list-search {
  height: 150px;
  overflow: auto;
  position: absolute;
  background: white;
  width: 95%;
  z-index: 10;
}
</style>